import { emitErrorToast } from "../../lib/errorToast";
import { trySealSecret } from "../../sealSecret";

const SAVE_ERROR = "Failed to save the secret. Please reload and try again.";

export async function sealSecretInput(
  input: HTMLInputElement,
  value: string,
  binding?: Parameters<typeof trySealSecret>[1],
  isCurrent?: () => boolean
) {
  if (isCurrent?.() ?? true)
    input.setCustomValidity("Please wait for the secret to finish saving.");
  try {
    const sealed = await trySealSecret(value, binding, isCurrent);
    if (isCurrent?.() ?? true)
      input.setCustomValidity(sealed === undefined ? SAVE_ERROR : "");
    return sealed;
  } catch {
    if (isCurrent?.() ?? true) {
      input.setCustomValidity(SAVE_ERROR);
      emitErrorToast({
        icon: "lock",
        message: SAVE_ERROR,
        buttonLabel: "Dismiss",
      });
    }
    return undefined;
  }
}
